import { saveLocalStorage, getLocalStorage, clearLocalStorage } from '@l/localStorage';

let login = {

  state: {
    token: getLocalStorage('token'), // 用户token
    moduleAuth: getLocalStorage('moduleAuth'), // 操作权限数组表
    breadData: [], // 面包屑数据
    showNews: false, // 是否有消息未处理
    showOrder: false, // 是否有新的指令
    userData: getLocalStorage('userData'), // 登录者信息
    menuData: [], // 首页菜单数据
    userMenu: [], // 菜单权限
  },

  mutations: {

    /**
         * 保存-token
         * @param {Object} state 状态对象
         * @param {String} data token
         */
    saveToken(state, data) {
      saveLocalStorage('token', data);
      state.token = data;
    },

    /**
         * 保存-userData
         * @param {Object} state 状态对象
         * @param {String} data 登录者信息
         */
    saveUserData(state, data) {
      saveLocalStorage('userData', data);
      state.userData = data;
    },

    /**
         * 保存-操作权限数组表
         * @param {Object} state 状态对象
         * @param {Array} data 权限数组
         */
    saveModuleAuth(state, data) {
      saveLocalStorage('moduleAuth', data);
      state.moduleAuth = data;
    },

    /**
         * 保存-面包屑数据
         * @param {Object} state 状态对象
         * @param {Array} data 面包屑数据
         */
    saveBreadData(state, data) {
      state.breadData = data;
    },

    /**
         * 保存-是否有消息未处理
         * @param {Object} state 状态对象
         * @param {Boolean} data 是否有消息未处理
         */
    saveShowNews(state, data) {
      state.showNews = data;
    },

    /**
         * 保存-是否有新的指令
         * @param {Object} state 状态对象
         * @param {Boolean} data 是否有新指令
         */
    saveShowOrder(state, data) {
      state.showOrder = data;
    },

    /**
         * 保存-主页菜单数据
         * @param {Object} state 状态对象
         * @param {Array} data 权限数组
         */
    saveMenuData(state, data) {
      saveLocalStorage('menuData', data);
      state.menuData = data;
    },

    /**
         * 保存-菜单权限
         * @param {Object} state 状态对象
         * @param {Array} data 权限数组
         */
    saveUserMenu(state, data) {
      saveLocalStorage('userMenu', data);
      state.userMenu = data;
    },

    /**
         * 退出登录
         * @param {Object} state 状态对象
         */
    logout(state) {
      state.token = null;
      clearLocalStorage();
    }
  },

  actions: {

  }
};

export {login};
